import { useState } from "react";
import { TIMELINE } from "@/data/content";
import { Reveal, Eyebrow } from "@/components/common";

const CATS = ["All", "History", "Philosophy", "Science", "Text"];
const CAT_COLOR = { History: "#C85A32", Philosophy: "#D4AF37", Science: "#D9B382", Text: "#9B1B30" };

export default function Timelines() {
  const [cat, setCat] = useState("All");
  const shown = TIMELINE.filter((e) => cat === "All" || e.cat === cat);

  return (
    <div className="pt-16 lg:pt-[72px]" data-testid="timelines-page">
      <section className="py-14 lg:py-20 border-b border-indic-gold/15">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
          <Eyebrow>Historical Timelines</Eyebrow>
          <h1 className="mt-3 font-serif text-5xl lg:text-6xl font-semibold text-amber-50">The Long Arc</h1>
          <p className="mt-4 max-w-2xl text-lg text-slate-300/90 leading-relaxed">Empires, texts, and discoveries along four thousand years of the subcontinent.</p>
          <div className="mt-6 flex flex-wrap gap-2">
            {CATS.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`timeline-filter-${c.toLowerCase()}`}
                className={`rounded-full px-4 py-1.5 text-sm transition-colors ${cat === c ? "bg-indic-gold text-indic-indigo" : "border border-indic-card-border text-slate-300 hover:border-indic-gold/40"}`}>
                {c}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-8">
          <div className="relative border-l-2 border-indic-card-border ml-3">
            {shown.map((e, i) => (
              <Reveal key={e.title} delay={0.03 * i}>
                <div className="relative pl-8 pb-12" data-testid={`timeline-event-${i}`}>
                  <span className="absolute -left-[9px] top-1.5 h-4 w-4 rounded-full border-2 border-[#0B1021]" style={{ background: CAT_COLOR[e.cat] }} />
                  <div className="flex items-center gap-3">
                    <span className="font-serif text-xl text-indic-gold">{e.year}</span>
                    <span className="text-[10px] font-sans uppercase tracking-wider px-2 py-0.5 rounded-full" style={{ color: CAT_COLOR[e.cat], border: `1px solid ${CAT_COLOR[e.cat]}55` }}>{e.cat}</span>
                  </div>
                  <h3 className="mt-2 font-serif text-2xl text-amber-50">{e.title}</h3>
                  <p className="mt-1.5 text-slate-300/85 leading-relaxed">{e.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
